document.addEventListener('DOMContentLoaded', function () {
    const carouselInner = document.querySelector('.carousel-inner');
    const leftBtn = document.querySelector('.carousel-btn-left');
    const rightBtn = document.querySelector('.carousel-btn-right');
  
    let currentIndex = 0;
    const cardCount = document.querySelectorAll('.carousel-card').length;
    const cardsPerView = window.innerWidth <= 768 ? 1 : 3;
  
    function updateCarousel() {
      const shift = -(currentIndex * (100 / cardsPerView));
      carouselInner.style.transform = `translateX(${shift}%)`;
    }
  
    leftBtn.addEventListener('click', () => {
      currentIndex = currentIndex > 0 ? currentIndex - 1 : cardCount - cardsPerView;
      updateCarousel();
    });
  
    rightBtn.addEventListener('click', () => {
      currentIndex = currentIndex < cardCount - cardsPerView ? currentIndex + 1 : 0;
      updateCarousel();
    });
  
    window.addEventListener('resize', () => {
      updateCarousel();
    });
});
  